import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  CardMedia,
  Divider,
} from "@mui/material";

import annaImg from "../assets/anna.png";
import maxImg from "../assets/max.png";
import leaImg from "../assets/lea.png";

const team = [
  {
    name: "Anna Müller",
    role: "Datenschutzexpertin",
    image: annaImg,
    details:
      "Anna ist spezialisiert auf DSGVO-konforme Prozesse und betreut Unternehmen in der Umsetzung von Datenschutzmaßnahmen.",
  },
  {
    name: "Max Schneider",
    role: "Fullstack Entwickler",
    image: maxImg,
    details:
      "Max entwickelt die technischen Kernkomponenten unserer Plattform und sorgt für Skalierbarkeit und Performance.",
  },
  {
    name: "Lea Wagner",
    role: "Produktdesign",
    image: leaImg,
    details:
      "Lea sorgt für intuitive Nutzererlebnisse und ein durchdachtes Design, das Funktionalität und Ästhetik vereint.",
  },
];

// FlipCard
const FlipCard = ({ member }) => {
  const [flipped, setFlipped] = useState(false);

  return (
    <Box
      sx={{
        width: 260,
        height: 300,
        perspective: "1000px",
        cursor: "pointer",
      }}
      onClick={() => setFlipped(!flipped)}
    >
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: 200,
          transformStyle: "preserve-3d",
          transition: "transform 0.6s",
          transformOrigin: "center center",
          transform: flipped ? "rotateY(180deg)" : "rotateY(0deg)",
        }}
      >
        {/* Front */}
        <Card
          sx={{
            position: "absolute",
            width: "100%",
            height: "100%",
            backfaceVisibility: "hidden",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "error.light",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 3,
            boxShadow: 4,
            p: 2,
            textAlign: "center",
            transition: "transform 0.3s",
            "&:hover": {
              transform: "scale(1.03)",
              boxShadow: 6,
            },
          }}
        >
          <CardMedia
            component="img"
            image={member.image}
            alt={member.name}
            sx={{
              width: 100,
              height: 100,
              borderRadius: "50%",
              objectFit: "cover",
              mb: 2,
            }}
          />
          <CardContent sx={{ p: 0 }}>
            <Typography variant="h6" color="primary.contrastText" gutterBottom>
              {member.name}
            </Typography>
            <Typography variant="body1" color="text.secondary">
              {member.role}
            </Typography>
          </CardContent>
        </Card>

        {/* Back */}
        <Card
          sx={{
            position: "absolute",
            width: "100%",
            height: "100%",
            backfaceVisibility: "hidden",
            transform: "rotateY(180deg)",
            borderRadius: 3,
            boxShadow: 4,
            backgroundColor: "secondary.light",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            p: 3,
            textAlign: "center",
          }}
        >
          <Typography variant="body1" color="secondary.contrastText">
            {member.details}
          </Typography>
        </Card>
      </Box>
    </Box>
  );
};

// AboutSection
export default function AboutSection() {
  return (
    <Container id="aboutSection" maxWidth="lg" sx={{ mt: 4 }}>
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          color="primary"
          align="center"
        >
          Über Uns
        </Typography>

      <Container maxWidth="md">
        <Typography align="center" sx={{ mb: 4 }} color="text.secondary">
          Wir sind ein engagiertes Team, das sich auf Datenschutzrecht und
          moderne Suchtechnologie spezialisiert hat.
        </Typography>

        <Grid container spacing={4} justifyContent="space-evenly">
          {team.map((member, idx) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              key={idx}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <FlipCard member={member} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Container>
  );
}
